import { render } from "./YesNoModal2.vue?vue&type=template&id=0dc6e8d2"
import script from "./YesNoModal2.vue?vue&type=script&lang=js"
export * from "./YesNoModal2.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__